import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../share/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsolidationConfirmComponent } from '../../share/modals/consolidation-confirm/consolidation-confirm.component';
import FetrapiEnums from "../../share/enum/enums";
import { DatasetModel } from '../../share/models/dataset-model.model';
import { EventService } from '../../share/services/event.service';
import { AppService } from '../../app.service';
import { SharedModule } from '../../share/shared.module';

@Component({
  selector: 'app-consolidation',
  templateUrl: './consolidation.component.html',
  styleUrls: ['./consolidation.component.css'],
  imports: [SharedModule]
})
export class ConsolidationComponent implements OnInit {
  labelText: string = '';
  output: string = '';
  isRunningConsolidation: boolean = false; 

  constructor(private eventService: EventService, private api: ApiService, private modalService: NgbModal, private appService: AppService) { 

    //Subscribe to the confirmaModal events
    this.eventService.getConsolidationConfirmEvent().subscribe(() => {  
      this.startConsolidation(true); 
    }) 
  } 

  ngOnInit(): void {
  }

  startConsolidation(skipWarnings: boolean) {
    this.isRunningConsolidation = true;
    this.api.startConsolidation(skipWarnings).subscribe({
      next: (res: any) => { 
        this.labelText = "The consolidation process has been launched. You will be notified when the process is complete.";
        this.isRunningConsolidation = false;
      },
      error: (error: any) => { 
        if (error.status == 400) {
          let message: string = '';
          if (error.error.message != null && error.error.message.toLowerCase() == 'exist datasets with status confirmationrequired') {
            message = 'The following datasets have status ConfirmationRequired:<br/><br/>';
            this.api.getDataSets('"' + FetrapiEnums.DatasetType.Grid + '"', '"' + FetrapiEnums.DatasetStatusCode.ConfirmationRequired + '"').subscribe({
              next: (data: any) => { //DatasetModel[]) => {
                for (let i = 0; i < data.length; i++) {
                  message += '<strong>' + data[i].memberName + '</strong><br/>';
                  message += data[i].datasetId + '<br/>';
                }

                message += '<br/>Are you sure you want to proceed with the Consolidation?';
                const modal = this.modalService.open(ConsolidationConfirmComponent);
                modal.componentInstance.showModal(message);

              },
              error: (error: any) => {}
            })
          } else {

            if (error.error.message != null && error.error.message.toLowerCase() == 'not all fetrapi members have a dataset in preparation or production') {
              message = error.error.message + '<br/><br/>';

              message += '<br/>Are you sure you want to proceed with the Consolidation?';
              const modal = this.modalService.open(ConsolidationConfirmComponent);
              modal.componentInstance.showModal(message);

            } else {
              this.appService.showModalError(error.error.message != null ? error.error.message : 'There is a problem executing the Consolidation');
            }
            
          }  
          
        } else {
          this.labelText = error.error.message;
          this.api.errorhandler(error);
        }
        this.isRunningConsolidation = false;
      }
    });
  }

}
